// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-0MD","col":"styles_col__3kWRM"};